import { render, staticRenderFns } from "./AudioPlayerWidget.vue?vue&type=template&id=200b613b&scoped=true&"
import script from "./AudioPlayerWidget.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayerWidget.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayerWidget.vue?vue&type=style&index=0&id=200b613b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b613b",
  null
  
)

export default component.exports